import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const eiwrsRandomizationSchemaServices = {
  //Randomization Schema
  addNewEIWRSRandomizationSchema,
  updateEIWRSRandomizationSchemaData,
  deleteEIWRSRandomizationSchemaData,
  softDeleteRestoreEIWRSRandomizationSchema,
  getEIWRSRandomizationSchemaData,
  getEIWRSSiteRandomizationSchemaData,
  getEIWRSSingleRandomizationSchemaData,
  assignUnassignStudyRandomizationSchemaSite,
  getAssignedRandomizationSchemaBySite,
  getRandomizationEventBasedonSchema,

  //Subject Randomization
  subjectRandomization,
  replaceSubjectRandomization,
  assignStudySubjectRandomizationKit,
  getAssignedStudySubjectRandomizationKit
};

// Subject Randomization
async function subjectRandomization(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}subjectRandomization`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Subject Replace Randomization
async function replaceSubjectRandomization(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}replaceSubjectRandomization`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Assign Study SUbject randomization Kit
async function assignStudySubjectRandomizationKit(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignStudySubjectRandomizationKit`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Add New Randomization Schema
async function addNewEIWRSRandomizationSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSRandomizationSchema`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Randomization Schema
async function updateEIWRSRandomizationSchemaData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSRandomizationSchemaData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Randomization Schema
async function softDeleteRestoreEIWRSRandomizationSchema(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSRandomizationSchema`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Randomization Schema
async function deleteEIWRSRandomizationSchemaData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSRandomizationSchemaData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Randomization Schema
async function getEIWRSRandomizationSchemaData(status, studyId, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSRandomizationSchemaData/${status}/${studyId}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSRandomizationSchemaData/${status}/${studyId}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Assign and Unassign Study Randomization Schema Site
async function assignUnassignStudyRandomizationSchemaSite(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignStudyRandomizationSchemaSite`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Single Randomization Schema
async function getEIWRSSingleRandomizationSchemaData(studyId, siteId, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getEIWRSSingleRandomizationSchemaData/${studyId}/${siteId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Assigned Randomization Schema by Site
async function getAssignedRandomizationSchemaBySite(studyId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedRandomizationSchemaBySite/${studyId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Randomization Event Based on Schema
async function getRandomizationEventBasedonSchema(studyId, schemaId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getRandomizationEventBasedonSchema/${studyId}/${schemaId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Site Randomization Schema
async function getEIWRSSiteRandomizationSchemaData(studyId, siteId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getEIWRSSiteRandomizationSchemaData/${studyId}/${siteId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Assign Study Subject randomization Kit
async function getAssignedStudySubjectRandomizationKit(studyId, siteId, subjectId, mode, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAssignedStudySubjectRandomizationKit/${studyId}/${siteId}/${subjectId}/${mode}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAssignedStudySubjectRandomizationKit/${studyId}/${siteId}/${subjectId}/${mode}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}